import { render, staticRenderFns } from "./UnionCity.vue?vue&type=template&id=14592fac&"
import script from "./UnionCity.vue?vue&type=script&lang=js&"
export * from "./UnionCity.vue?vue&type=script&lang=js&"
import style0 from "./UnionCity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports